<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="blz-fusion.info.title"></h4>
  </div>
  <div class="modal-body">
    <div class="has-text-grey mb-4" translate="blz-fusion.info.one"></div>
    <div class="has-text-grey mb-4" translate="blz-fusion.info.two"></div>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="blz"
          (blur)="addBlz($event)"
          inputAutocompleteOff
          validationIndicator
        >
          <button
            [disabled]="form.invalid"
            fino-button
            label="blz-fusion.add"
            input-right
            (click)="addBlz($event)"
          ></button>
        </fino-input>
      </div>

      <div class="is-flex is-flex-direction-column">
        @for (blz of deprecatedBankCodes; track blz) {
          <span class="tag is-primary mb-2 is-large">
            {{ blz | blz }}
            <button (click)="removeBlz(blz)" class="ml-2 delete"></button>
          </span>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="noBlzToBeFusioned"
        (click)="submit()"
        fino-button
        label="blz-fusion.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="blz-fusion.abort"
      ></button>
    </div>
  </div>
</div>
